import { useState, useEffect, useCallback, useRef } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import { getLinkedInAccounts, getConnectedEmailAccounts } from '../services/settingsService';

type Channel = 'linkedin' | 'email';

interface AccountNameMap {
  [accountId: string]: string;
}

export function useAgentSenderName(channel: Channel) {
  const { profile } = useProfile();
  const [accountNames, setAccountNames] = useState<AccountNameMap>({});
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const load = async () => {
      const map: AccountNameMap = {};
      if (channel === 'linkedin') {
        const accounts = await getLinkedInAccounts();
        for (const a of accounts) {
          if (a.id && a.linkedin_profile_name) {
            map[a.id] = a.linkedin_profile_name;
          }
        }
      } else {
        const accounts = await getConnectedEmailAccounts();
        for (const a of accounts) {
          if (a.id && a.display_name) {
            map[a.id] = a.display_name;
          }
        }
      }
      setAccountNames(map);
    };

    load();
  }, [channel]);

  const getAgentLabel = useCallback(
    (accountId?: string | null): string => {
      const companyName = profile?.company_name || '';
      let agentName = '';

      if (accountId && accountNames[accountId]) {
        agentName = accountNames[accountId];
      }

      if (companyName && agentName) {
        return `${companyName} | ${agentName}`;
      }
      if (companyName) return companyName;
      if (agentName) return agentName;
      return 'AI Agent';
    },
    [profile?.company_name, accountNames],
  );

  return { getAgentLabel };
}
